<template>
  <div class="salary">
    <div class="salary-header">
      <div class="salary-header__title"></div>
    </div>
		<div class="salary-content">
			 <div class="salary-div" v-for="item in benefitList" :key="item.id"  @click="onItemClick(item)">
					<img :src="`${imgPrefix}${item.activityImgUrl}`" />
		</div>
		</div>
   
  </div>
</template>

<script>
import { reactive, toRef, onMounted } from 'vue'
import { Dialog } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import globalVariables from '@/utils/globalVariables'
import api from '@/api'

export default {
  setup() {
    const router = useRouter()
    const route = useRoute()
    const { activityCode } = route.query
    const data = reactive({
      benefitList: [],
      hasRight: true,
			isMessage:""
    })

    const onItemClick = benefit => {
      if(!data.hasRight) {
        Dialog.alert({
          message: data.isMessage
        })
        return
      }
      if (benefit.stock === 0) {
        Dialog.alert({
          message: '该商品已售罄'
        })
        return
      }
      router.push({
        path: '/productDetail',
        query: {
          id: benefit.id,
          activityCode
        }
      })
    }

    onMounted(() => {
      document.title = ''
      api
        .getProductList({
          activityCode
        })
        .then(res => {
          data.benefitList = res.data
        })

      api
        .isHaveRight({
          activityCode
        })
        .then(res => {
          const { status, message } = res.data
          if (status === -1) {
            data.hasRight = false
						data.isMessage = message
            Dialog({
              title: '友情提醒',
              message
            })
          }
        })
    })
    return {
      imgPrefix: globalVariables.imgPrefix,
      benefitList: toRef(data, 'benefitList'),
			isMessage: toRef(data, 'isMessage'),
      hasRight: toRef(data, 'hasRight'),
      onItemClick
    }
  }
}
</script>

<style lang="less" scoped>
.salary {
  min-height: 100vh;
  background-image: url(https://cos.ue-link.cn/image/salary-bg.png);
  background-repeat: repeat, no-repeat;
  background-size: 100%;
  background-position: left top, center -120px;
  .salary-header {
    overflow: hidden;
    .salary-header__title {
      width: 286px;
      height: 70px;
      background-image: url(https://cos.ue-link.cn/image/salary-title.png);
      background-repeat: no-repeat;
      background-size: 100%;
      margin: 24px 0 0 44px;
    }
  }
	.salary-content{
		display: flex;
		flex-wrap: wrap;
		margin-top: 9px;
		padding-bottom: 30px;
	}
	.salary-div{
		width: 90%;
		height: 70px;
		
		margin: auto;
		margin-bottom: 10px;
	}
	.salary-div > img{
		width: 100%;
		height: 100%;
	}
}
</style>